export class RedirectService {
    /* @ngInject */
    constructor(egUrlService, flowStateService, $http, $q, $log) {
        this.egUrlService = egUrlService;
        this.flowStateService = flowStateService;
        this.$http = $http;
        this.$q = $q;
        this.$log = $log;
    }

    resolveRedirectUrl() {
        let installationUserId = this.flowStateService.getInstallationUserId();

        let url = this.egUrlService.url(`/authentication/redirect?installationUserId={{installationUserId}}`, {
            installationUserId: installationUserId,
        });

        return this.$http.get(url)
            .then(response => { return response.data; })
            .catch(response => { return this._redirectError(response); });
    }

    _redirectError(response){
        this.$log.error('Failed to get installation login url: ' + response.statusText);
        this.$q.reject(response.statusText);
    }
}
